// This file configures the initialization of Sentry on the browser.
// The config you add here will be used whenever a page is visited.
// https://docs.sentry.io/platforms/javascript/guides/nextjs/
;globalThis["_sentryRouteManifest"] = "{\"dynamicRoutes\":[],\"staticRoutes\":[],\"isrRoutes\":[]}";globalThis["_sentryNextJsVersion"] = "16.4.5";import * as Sentry from "@sentry/nextjs";

function censorSensitiveInformation(event) {
  const keys = ["password", "secret", /token$/i, "credentials"];

  for (const eventKey in event) {
    const removeKey = keys.reduce(
      (result, key) => result || eventKey.match(key) !== null,
      false
    );

    if (removeKey) {
      delete event[eventKey];
    } else if (typeof event[eventKey] === "object") {
      censorSensitiveInformation(event[eventKey]);
    }
  }
}

const SENTRY_DSN =
  process.env.NEXT_PUBLIC_CLIENT_SENTRY_DSN || process.env.SENTRY_DSN;

Sentry.init({
  initialScope: {
    tags: {
      isSSR: typeof window === "undefined",
    },
  },
  dsn:
    SENTRY_DSN ||
    "https://21da1ac6c4f743e3b7c83420fdd69ae9@o23399.ingest.sentry.io/5671782",

  environment: process.env.NEXT_PUBLIC_ENVIRONMENT || "",

  // Associate error events with a release version, so we can track which
  // release introduced new bugs. More info on Sentry releases:
  // https://docs.sentry.io/learn/releases/
  release: process.env.NEXT_PUBLIC_COMMIT_SHA || "unknown-browser-release",

  ignoreErrors: [
    // Ignore http://bit.ly/2hk42Ap, resulting from what
    // appears to be a Chrome bug http://bit.ly/2gVbncS
    /__gCrWeb\.autofill\.extractForms/,
    // Ignore http://bit.ly/2hk71Zv, resulting from
    // some really strange issue in Safari 9. Experienced
    // by Mozilla team, too http://bit.ly/2hk9vHq
    /docs-homescreen-gb-container/,
    // Ignore http://bit.ly/2mVGcgX. It's a weird react error.
    // Google says it _might_ be a logging error? http://bit.ly/2lEB3ZW
    /e\.getHostNode/,
    // Ignore http://bit.ly/2lyZSao, resulting from
    // some Chrome plugin presumably.
    /ahk_main/,
    // Some weird firefox errors that seem to happen only on firefox for iOS.
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1394296
    /__firefox__\./,
    /ResizeObserver/,
    // Bing Instant Search bug from Edge iOS that can be ignored
    /instantSearchSDKJSBridgeClearHighlight/,
    // Ignore errors from some Chrome extensions
    /_chromeNamespace/,
  ],

  integrations: [Sentry.replayIntegration()],

  allowUrls: [/zapier\.com/, /zapier-staging\.com/, /zapier-deployment\.com/],

  denyUrls: [
    // Known 3rd party scripts
    /cookielaw\.org\//i,
    // Chrome extensions
    /extensions\//i,
    /^chrome:\/\//i,
    // Google Tag Manager issues
    /\/(gtm|ga)\.js/i,
  ],

  beforeSend(event) {
    censorSensitiveInformation(event);

    return event;
  },
});

// This export will instrument router navigations, and is only relevant if you enable tracing.
// `captureRouterTransitionStart` is available from SDK version 9.12.0 onwards
export const onRouterTransitionStart = Sentry.captureRouterTransitionStart;
